import { FuseNavigationItem } from "@fuse/components/navigation"

export const spaceHeaderClass = {
    "CDC": "bg-red-600",
    "normal": "bg-corpo-darkgreen"
}


export const spaceSidebarClass = {
    "CDC": "bg-white text-black",
    "normal": "bg-corpo-darkgreen"
}

const accueilSubMenuRegexStringList = ["/cdc-company-view/[0-9]+", "/cdc-donnees-financieres/[0-9]+", "/cdc-actualites/[0-9]+", "/cdc-analyse-financiere/[0-9]+"]

export const cdcMenu = [
        {
            title: 'Accueil',
            type: 'basic',
            icon: ['fas', 'house'],
            link: '/cdc-space-home',
            active_classes: {
                icon: 'text-white',
                title: 'text-white',
                wrapper: 'bg-red-600'
            },
            classes: {
                icon: 'text-black',
                title: 'text-black',
                wrapper: 'hover:bg-gray-100 bg-white'
            },
            children: [
                {
                    title: 'Présentation & Stratégie',
                    type: 'basic',
                    icon: ['fas', 'earth-europe'],
                    link: '/cdc-company-view/:id',
                    showFunction: s => accueilSubMenuRegexStringList.find(mR => new RegExp(mR).test(s)) != null,
                },
                {
                    title: 'Actualités & Earnings calls',
                    type: 'basic',
                    icon: ['fas', 'satellite-dish'],
                    link: '/cdc-actualites/:id',
                    showFunction: s => accueilSubMenuRegexStringList.find(mR => new RegExp(mR).test(s)) != null,
                },
                {
                    title: 'Analyse financière',
                    type: 'basic',
                    icon: ['fas', 'chart-line'],
                    link: '/cdc-analyse-financiere/:id',
                    showFunction: s => accueilSubMenuRegexStringList.find(mR => new RegExp(mR).test(s)) != null,
                },
                {
                    title: 'ESG',
                    type: 'basic',
                    icon: ['fas', 'leaf'],
                    showFunction: s => accueilSubMenuRegexStringList.find(mR => new RegExp(mR).test(s)) != null,
                },
                {
                    title: 'Peer Group',
                    type: 'basic',
                    icon: ['fas', 'table'],
                    showFunction: s => accueilSubMenuRegexStringList.find(mR => new RegExp(mR).test(s)) != null,
                },
                {
                    title: 'Données financières',
                    type: 'basic',
                    icon: ['fas', 'magnifying-glass-chart'],
                    link: '/cdc-donnees-financieres/:id',
                    showFunction: s => accueilSubMenuRegexStringList.find(mR => new RegExp(mR).test(s)) != null,
                }
            ]
        }
    ] as FuseNavigationItem[]
